import firebase from 'firebase'
import firestore from 'firebase/firestore'
// Initialize Firebase
var config = {
   apiKey: "AIzaSyCQqITZTr4lSVFlyXjBSbKI0ehl6vwase4",
   authDomain: "contents-chat.firebaseapp.com",
   databaseURL: "https://contents-chat.firebaseio.com",
   projectId: "contents-chat",
   storageBucket: "contents-chat.appspot.com",
   messagingSenderId: "274463602330"
 };

 const firebaseApp = firebase.initializeApp(config);
 firebaseApp.firestore().settings({ timestampsInSnapshots: true })

 export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js